import { createFileRoute } from "@tanstack/react-router";
import { ThemeSlot } from "../../themes/slots";

export const Route = createFileRoute("/c/shop")({
  component: RouteComponent,
  validateSearch: (search: { category?: string; search?: string }) => ({
    category: search.category,
    search: search.search,
  }),
});

function RouteComponent() {
  const { category, search } = Route.useSearch();
  return (
    <ThemeSlot
      slot="productListing"
      preselectedCategory={category}
      searchQuery={search}
    />
  );
}
